/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class Evaluate extends Ce {
    constructor() {
        super();
        this.baseUrl += '/evaluate';
    }

    data({ title, currentPage, pageSize } = {}) {
        return super.get('/data', {
            title,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, title, remarks, evaluateDetailList } = {}) {
        return super.post('/save', {
            id,
            title,
            remarks,
            evaluateDetailJson: JSON.stringify(evaluateDetailList),
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new Evaluate();
export { Evaluate };
